import { zergApi } from "@/service/zerg";

class PayrollPeriodService {

    async listPeriods() {
        try {
            const data = await zergApi.get("/rrhh/payroll/periods/list");
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getCurrentPeriod() {
        try {
            const data = await zergApi.get("/rrhh/payroll/periods/current");
            return data;
        } catch (error) {
            throw error;
        }
    }

    async openPeriod(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/periods/open", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getClosePeriodSummary(periodId) {
        try {
            const data = await zergApi.get(`/rrhh/payroll/periods/close-summary/${periodId}`);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async closePeriod(periodId, params) {
        try {
            const data = await zergApi.post(`/rrhh/payroll/periods/close/${periodId}`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportReportePagos(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/periods/export-reporte-pagos", params, {
                responseType: "blob",
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportAfpnet(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/periods/export-afpnet", params, {
                responseType: "blob",
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async previewPagoAfp(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/periods/pago-afp/preview", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async enviarPagoAfp(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/periods/pago-afp/enviar", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEmpresas(params = {}) {
        try {
            const data = await zergApi.post("/setting/payroll/get-empresas", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new PayrollPeriodService();
